import React from "react";
import { Card, CardContent, Typography, LinearProgress, Divider } from "@mui/material";

export default function OverviewStatCard({
  title,               // e.g., "Blue Cash Preferred"
  subtitle = "",       // e.g., "****2015"
  progressLabel = "",  // e.g., "16% utilization"
  progressValue = null,// number 0-100 or null
  topRows = [],        // [{ label, value }]
  bottomRows = [],     // [{ label, value }]
}) {
  return (
    <Card
      sx={{
        bgcolor: "transparent",
        borderRadius: 2,
        border: "1px solid",
        borderColor: "divider",
        boxShadow: 0,
      }}
    >
      <CardContent>
        {title && (
          <Typography variant="subtitle1" fontWeight="bold">
            {title}
          </Typography>
        )}
        {subtitle && (
          <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
            {subtitle}
          </Typography>
        )}

        {progressLabel && (
          <Typography variant="body2" color="text.secondary">
            {progressLabel}
          </Typography>
        )}
        {typeof progressValue === "number" && (
          <LinearProgress
            variant="determinate"
            value={progressValue}
            sx={{ height: 8, borderRadius: 5, mb: 1 }}
          />
        )}

        {topRows.map((row, i) => (
          <Typography key={i} variant="body2" color="text.secondary">
            {row.label}: {row.value}
          </Typography>
        ))}

        {bottomRows.length > 0 && (
          <>
            <Divider sx={{ my: 1 }} />
            {bottomRows.map((row, i) => (
              <Typography key={i} variant="body2">
                {row.label}: <strong>{row.value}</strong>
              </Typography>
            ))}
          </>
        )}
      </CardContent>
    </Card>
  );
}
